import { makeCall } from '../api.js';
import {isAuthenticated} from '../authHelpers';

export const getUserData = () => {
    return makeCall({
        method: 'GET',
        action: 'account/settings'
    });
};

export const updateUserData = (userData) => {
    return makeCall({
        method: 'POST',
        action: 'account/settings',
        body: JSON.stringify(userData)
    });
};
export const updateNotifyTime = (time) => {
    return makeCall({
        method: 'POST',
        action: 'account/notify',
        body: JSON.stringify(time.notifyScheduleTime)
    });
};

export const getLegalTypes = () => {

  let LegalTypes = getLegalTypesFromSessionStorage();
  if(LegalTypes){
    return new Promise((res) => res(LegalTypes));
  }
  else{
    return makeCall({
      method: 'GET',
      action: 'legal/types'
    });
  }

};

export const getUserLegals = () => {
    return makeCall({
        method: 'GET',
        action: 'account/legal'
    });
};


export const addOrUpdateLegals = (userLegals) => {
    return makeCall({
        method: 'POST',
        action: 'account/legal',
        body: JSON.stringify(userLegals)
    });
};

export const removeUserLegals = (userLegals) => {
    return makeCall({
        method: 'DELETE',
        action: 'account/legal',
        body: JSON.stringify(userLegals)
    });
};

export const getPaymentsDefault = () => {
    return makeCall({
        method: 'GET',
        action: 'payments/default'
    });
};
export const setPaymentsDefault = (id) => {
    return makeCall({
        method: 'POST',
        action: 'payments/default',
        body: JSON.stringify(id)
    });
};

export const getUserAddresses = () => {
    return makeCall({
        method: 'GET',
        action: 'account/address'
    });
};

export const addOrUpdateAddresses = (userAddresses) => {
    return makeCall({
        method: 'POST',
        action: 'account/address',
        body: JSON.stringify(userAddresses)
    });
};

export const removeUserAddresses = (userAddresses) => {
    return makeCall({
        method: 'DELETE',
        action: 'account/address',
        body: JSON.stringify(userAddresses)
    });
};
export const getUserEmails = () => {
  return makeCall({
    method: 'GET',
    action: 'account/emails'
  });
};
export const addOrUpdateEmail = (userEmail) => {
  return makeCall({
    method: 'POST',
    action: 'account/emails',
    body: JSON.stringify(userEmail)
  });
};
export const removeUserEmail = (userEmail) => {
  return makeCall({
    method: 'DELETE',
    action: 'account/emails',
    body: JSON.stringify(userEmail)
  });
};
export const getUserGarage = () => {
    return makeCall({
        method: 'GET',
        action: 'account/garage'
    });
};

export const updateUserGarage = (garage) => {
    return makeCall({
        method: 'POST',
        action: 'account/garage',
        body: JSON.stringify(garage)
    });
};

export const deleteUserGarage = (garage) => {
    return makeCall({
        method: 'DELETE',
        action: 'account/garage',
        body: JSON.stringify(garage)
    });
};


/**
 * User transactions
 */
export const getUserTransactions = (filters) => {
    return makeCall({
        method: 'POST',
        action: 'payments/transactions',
        body: JSON.stringify(filters)
    });
};

export const getUserTransactionsWithDateLimits = ({startDate, finishDate}) => {
    return makeCall({
        mathod: 'GET',
        action: `payments/transactions?startDate=${startDate}&finishDate=${finishDate}`
    });
};
/**
 * User orders
 */
export const getPortionStates = () => {
  return makeCall({
    method: 'GET',
    action: 'portion/portionstates'
  });
};
export const getUserInmotions = (filters) => {
  return makeCall({
    method: 'POST',
    action: `order/infinityscroll`,
    body: JSON.stringify(filters)
  });
};

export const getUserOrdersCount = () => {
  return makeCall({
    method: 'GET',
    action: 'order/count'
  });
};
export const setPortionToArchive = (id) => {
  return makeCall({
    method: 'POST',
    action: 'order/archivecanceled',
    body: JSON.stringify({portionId: id})
  });
};

export const deleteSocialNetwork = (socialNetworksData) => {
    return makeCall({
        method: 'DELETE',
        action: 'account/removesocialnetwork',
        body: JSON.stringify(socialNetworksData)
    });
};

export const getPartialSettings = () => {
  let PartialSettings = getPartialSettingsFromSessionStorage();
  if(PartialSettings){
    return new Promise((res) => res(PartialSettings));
  }
  else {
    if(isAuthenticated())
      return makeCall({
        method: 'GET',
        action: 'account/partialSettings'
      });
  }

};
export const setPartialSettings = (settings) => {
  let PartialSettings = getPartialSettingsFromSessionStorage();
  if(!PartialSettings){
    return new Promise((res) => res(setPartialSettingsToSessionStorage(settings)));
  }
  else {
    return new Promise((res) => res('success'));
  }

};

/* sessionStorage CRUD Legals*/

export function getLegalTypesFromSessionStorage() {
  return JSON.parse(sessionStorage.getItem('types'));
}

export function setLegalTypesToSessionStorage(types) {
  sessionStorage.setItem('types', JSON.stringify(types));
  return 'success';
}

export function removeLegalTypesFromSessionStorage() {
  sessionStorage.removeItem('types');
}

/* sessionStorage CRUD partialSettings*/

export function getPartialSettingsFromSessionStorage() {
  return JSON.parse(sessionStorage.getItem('partialSettings'));
}

export function setPartialSettingsToSessionStorage(partialSettings) {
  sessionStorage.setItem('partialSettings', JSON.stringify(partialSettings));
  return 'success';
}

export function removePartialSettingsFromSessionStorage() {
  sessionStorage.removeItem('partialSettings');
}

export function updatePartialSettingsToSessionStorage(key, value) {
  let PartialSettings = getPartialSettingsFromSessionStorage();
  PartialSettings[key] = value;
  return setPartialSettingsToSessionStorage(PartialSettings);
}



/** WEBPACK FOOTER **
 ** ./src/logic/api/userData.js
 **/